import { all, fork, takeLatest } from 'redux-saga/effects';
import {
    APPLY_POLICY_ADJUSTMENT,
    APPLY_POLICY_ADJUSTMENT_CHANGES,
    COMPLETE_CANCELLATION,
    CREATE_CANCELLATION,
    CREATE_ENDORSEMENT,
    DELETE_CANCELLATION,
    DELETE_POLICY_ADJUSTMENT,
    EXECUTE_POLICY_ACTION,
    EXECUTE_POLICY_TRANSACTION_CUSTOM_ACTION,
    GET_CANCELLATION,
    GET_LOG_CONTENT,
    GET_LOGS,
    GET_NOTES,
    GET_OPTA,
    GET_OPTA_ESTIMATOR,
    GET_OVERRIDABLE_ERRORS,
    GET_POLICY,
    GET_POLICY_ADJUSTMENTS,
    GET_POLICY_SUMMARY,
    GET_POLICY_TERMS,
    GET_POLICY_TEST_OVERRIDE,
    GET_POLICY_VALIDATION_INFO,
    GET_TOOLTIP_INFO,
    GET_UNDERWRITER_REVIEW_LINK,
    OVERRIDE_CANCELLATION_REFUND,
    QUERY_POLICY,
    QUOTE_CANCELLATION,
    REGENERATE_DOCUMENTS,
    SEND_EMAIL_REQUEST,
    SET_ENDORSEMENT_TO_LOST,
    SET_POLICY_TEST_OVERRIDE,
    UPDATE_CANCELLATION_DATE,
    UPDATE_PLACE,
    UPSERT_NOTE,
    UPSERT_POLICY,
    UPSERT_TOOLTIP_INFO,
} from '../../constants/actions/policy';
import { applyPolicyAdjustmentChangesSaga } from './applyPolicyAdjustmentChangesSaga';
import { applyPolicyAdjustmentSaga } from './applyPolicyAdjustmentSaga';
import { completeCancellationSaga } from './completeCancellationSaga';
import { createCancellationSaga } from './createCancellationSaga';
import { createEndorsementSaga } from './createEndorsementSaga';
import { deleteCancellationSaga } from './deleteCancellationSaga';
import { deletePolicyAdjustmentSaga } from './deletePolicyAdjustmentSaga';
import { executePolicyActionSaga } from './executePolicyActionSaga';
import { executePolicyTransactionCustomActionSaga } from './executePolicyTransactionCustomActionSaga';
import { getCancellationSaga } from './getCancellationSaga';
import { getLogContentSaga } from './getLogContentSaga';
import { getLogsSaga } from './getLogsSaga';
import { getNotesSaga } from './getNotesSaga';
import { getOptaEstimatorSaga } from './getOptaEstimatorSaga';
import { getOptaSaga } from './getOptaSaga';
import { getOverridableErrorsSaga } from './getOverridableErrorsSaga';
import { getPolicyAdjustmentsSaga } from './getPolicyAdjustmentsSaga';
import { getPolicySaga } from './getPolicySaga';
import { getPolicySummarySaga } from './getPolicySummarySaga';
import { getPolicyTermsSaga } from './getPolicyTermsSaga';
import { getPolicyTestOverrideSaga } from './getPolicyTestOverrideSaga';
import { getPolicyValidationInfoSaga } from './getPolicyValidationInfoSaga';
import { getTooltipInfoSaga } from './getTooltipInfoSaga';
import { getUnderwriterReviewLinkSaga } from './getUnderwriterReviewLinkSaga';
import { overrideCancellationRefundSaga } from './overrideCancellationRefundSaga';
import { queryPolicySaga } from './queryPolicySaga';
import { quoteCancellationSaga } from './quoteCancellationSaga';
import { regenerateDocumentsSaga } from './regenerateDocumentsSaga';
import { sendEmailRequestSaga } from './sendEmailRequestSaga';
import { setEndorsementToLostSaga } from './setEndorsementToLostSaga';
import { setPolicyTestOverrideSaga } from './setPolicyTestOverrideSaga';
import { updateCancellationDateSaga } from './updateCancellationDateSaga';
import { updatePlaceSaga } from './updatePlaceSaga';
import { upsertNoteSaga } from './upsertNoteSaga';
import { upsertPolicySaga } from './upsertPolicySaga';
import { upsertTooltipInfoSaga } from './upsertTooltipInfoSaga';

function* watchGetPolicy() {
    yield takeLatest(GET_POLICY, getPolicySaga);
}

function* watchGetPolicySummary() {
    yield takeLatest(GET_POLICY_SUMMARY, getPolicySummarySaga);
}

function* watchQueryPolicy() {
    yield takeLatest(QUERY_POLICY, queryPolicySaga);
}

function* watchExecutePolicyAction() {
    yield takeLatest(EXECUTE_POLICY_ACTION, executePolicyActionSaga);
}

function* watchUpsertPolicy() {
    yield takeLatest(UPSERT_POLICY, upsertPolicySaga);
}

function* watchGetLogs() {
    yield takeLatest(GET_LOGS, getLogsSaga);
}

function* watchGetLogContent() {
    yield takeLatest(GET_LOG_CONTENT, getLogContentSaga);
}

function* watchGetPolicyValidationInfo() {
    yield takeLatest(GET_POLICY_VALIDATION_INFO, getPolicyValidationInfoSaga);
}

function* watchGetTooltipInfo() {
    yield takeLatest(GET_TOOLTIP_INFO, getTooltipInfoSaga);
}

function* watchUpsertTooltipInfo() {
    yield takeLatest(UPSERT_TOOLTIP_INFO, upsertTooltipInfoSaga);
}

function* watchGetOpta() {
    yield takeLatest(GET_OPTA, getOptaSaga);
}

function* watchGetOptaEstimator() {
    yield takeLatest(GET_OPTA_ESTIMATOR, getOptaEstimatorSaga);
}

function* watchSendEmailRequest() {
    yield takeLatest(SEND_EMAIL_REQUEST, sendEmailRequestSaga);
}

function* watchRegenerateDocuments() {
    yield takeLatest(REGENERATE_DOCUMENTS, regenerateDocumentsSaga);
}

function* watchUpdatePlace() {
    yield takeLatest(UPDATE_PLACE, updatePlaceSaga);
}

function* watchUpsertNote() {
    yield takeLatest(UPSERT_NOTE, upsertNoteSaga);
}

function* watchGetNote() {
    yield takeLatest(GET_NOTES, getNotesSaga);
}

function* watchExecutePolicyTransactionCustomAction() {
    yield takeLatest(EXECUTE_POLICY_TRANSACTION_CUSTOM_ACTION, executePolicyTransactionCustomActionSaga);
}

function* watchGetUnderwriterReviewLink() {
    yield takeLatest(GET_UNDERWRITER_REVIEW_LINK, getUnderwriterReviewLinkSaga);
}

function* watchGetPolicyAdjustments() {
    yield takeLatest(GET_POLICY_ADJUSTMENTS, getPolicyAdjustmentsSaga);
}

function* watchApplyPolicyAdjustment() {
    yield takeLatest(APPLY_POLICY_ADJUSTMENT, applyPolicyAdjustmentSaga);
}

function* watchApplyPolicyAdjustmentChanges() {
    yield takeLatest(APPLY_POLICY_ADJUSTMENT_CHANGES, applyPolicyAdjustmentChangesSaga);
}

function* watchDeletePolicyAdjustment() {
    yield takeLatest(DELETE_POLICY_ADJUSTMENT, deletePolicyAdjustmentSaga);
}

function* watchGetOverridableErrors() {
    yield takeLatest(GET_OVERRIDABLE_ERRORS, getOverridableErrorsSaga);
}

function* watchGetPolicyTestOverride() {
    yield takeLatest(GET_POLICY_TEST_OVERRIDE, getPolicyTestOverrideSaga);
}

function* watchSetPolicyTestOverride() {
    yield takeLatest(SET_POLICY_TEST_OVERRIDE, setPolicyTestOverrideSaga);
}

function* watchCreateEndorsement() {
    yield takeLatest(CREATE_ENDORSEMENT, createEndorsementSaga);
}

function* watchSetEndorsementToLost() {
    yield takeLatest(SET_ENDORSEMENT_TO_LOST, setEndorsementToLostSaga);
}

function* watchCreateCancellation() {
    yield takeLatest(CREATE_CANCELLATION, createCancellationSaga);
}

function* watchQuoteCancellation() {
    yield takeLatest(QUOTE_CANCELLATION, quoteCancellationSaga);
}

function* watchDeleteCancellation() {
    yield takeLatest(DELETE_CANCELLATION, deleteCancellationSaga);
}

function* watchUpdateCancellationDate() {
    yield takeLatest(UPDATE_CANCELLATION_DATE, updateCancellationDateSaga);
}

function* watchGetCancellation() {
    yield takeLatest(GET_CANCELLATION, getCancellationSaga);
}

function* watchOverrideCancellationRefund() {
    yield takeLatest(OVERRIDE_CANCELLATION_REFUND, overrideCancellationRefundSaga);
}

function* watchCompleteCancellation() {
    yield takeLatest(COMPLETE_CANCELLATION, completeCancellationSaga);
}

function* watchGetPolicyTerms() {
    yield takeLatest(GET_POLICY_TERMS, getPolicyTermsSaga);
}

function* root() {
    return yield all([
        fork(watchGetPolicy),
        fork(watchGetPolicySummary),
        fork(watchQueryPolicy),
        fork(watchExecutePolicyAction),
        fork(watchUpsertPolicy),
        fork(watchGetLogs),
        fork(watchGetLogContent),
        fork(watchGetPolicyValidationInfo),
        fork(watchGetTooltipInfo),
        fork(watchUpsertTooltipInfo),
        fork(watchGetOpta),
        fork(watchGetOptaEstimator),
        fork(watchRegenerateDocuments),
        fork(watchSendEmailRequest),
        fork(watchUpdatePlace),
        fork(watchUpsertNote),
        fork(watchGetNote),
        fork(watchExecutePolicyTransactionCustomAction),
        fork(watchGetUnderwriterReviewLink),
        fork(watchGetPolicyAdjustments),
        fork(watchApplyPolicyAdjustment),
        fork(watchApplyPolicyAdjustmentChanges),
        fork(watchDeletePolicyAdjustment),
        fork(watchGetOverridableErrors),
        fork(watchGetPolicyTestOverride),
        fork(watchSetPolicyTestOverride),
        fork(watchCreateEndorsement),
        fork(watchSetEndorsementToLost),
        fork(watchCreateCancellation),
        fork(watchQuoteCancellation),
        fork(watchDeleteCancellation),
        fork(watchUpdateCancellationDate),
        fork(watchGetCancellation),
        fork(watchOverrideCancellationRefund),
        fork(watchCompleteCancellation),
        fork(watchGetPolicyTerms),
    ]);
}

export default root;
